import tempMeeApi from '../../../apis/tempMee';

/**
 * The admin-authed, org-service-backed office route. One definition for the
 * production path, mirroring the `INTERNAL_USERS_ENDPOINT` convention. Tests
 * pin the literal wire path independently rather than import this, so a typo
 * here can't silently agree with its own tests.
 *
 * @param {string} officeId - the office's user id
 * @returns {string} the `/admin/office/:id` path
 */
export const officeRoute = (officeId) => `/admin/office/${officeId}`;

/**
 * GOTU-5263 — fetch the office-profile contract for a DNT office from the
 * admin-authed, org-service-backed monolith route. The admin-authed sibling of
 * `/office`; it 404s for a non-DNT user, which the caller treats as "fall back
 * to the monolith read". HTTP only — no error handling and no reshaping (the
 * service applies `toOfficeSlice`).
 *
 * @param {string} officeId - the office's user id (same id as `/admin/users/:id`)
 * @returns {Promise<import('../types/Office.api').IOfficeContractResponse>} contract body
 */
export const getOffice = async (officeId) => {
  const response = await tempMeeApi.get(officeRoute(officeId));

  return response.data;
};
